import { Navigate, useLocation } from 'react-router-dom';

export default function RedirectToLogin() {
  const { pathname } = useLocation();

  return <Navigate to={`/login?redirect_to=${pathname}`} replace={true} />;
}
